module.exports = __webpack_public_path__ + "img/homeimg01.f88b7722.png";